import { createUseStyles } from 'react-jss'
import { trafficGreenDark, black, mediumGrey, trafficRedDark } from '../../../styles/const/colors'
import { defaultBorderRadius, transitionShort } from '../../../styles/const/common'

const useStyles = createUseStyles(theme => ({
  container: {
    marginTop: 16,
    marginBottom: 4
  },
  icon: {
    display: 'flex',
    fontSize: 36,
    marginBottom: 7
  },
  selectFiles: {
    display: 'block',
    textDecoration: 'underline'
  },
  actionText: {
    margin: 0,
    width: '100%',
    fontSize: '14px',
    textAlign: 'center'
  },
  baseStyle: {
    flex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '40px 20px',
    borderWidth: 2,
    borderColor: mediumGrey,
    borderStyle: 'dashed',
    borderRadius: defaultBorderRadius,
    backgroundColor: 'rgba(0,0,0,0)',
    color: black,
    outline: 'none',
    transition: transitionShort,
    cursor: 'pointer',

    '&:hover': {
      borderColor: theme.brandPrimary
    }
  },
  activeStyle: {
    borderColor: theme.brandPrimary,
    backgroundColor: theme.brandPrimaryLight
  },
  acceptStyle: {
    borderColor: trafficGreenDark
  },
  rejectStyle: {
    borderColor: trafficRedDark
  }
}))

export default useStyles
